import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { FailedSolutionsSection } from '../components/FailedSolutionsSection';
import { SolutionSection } from '../components/SolutionSection';
import { IncludesSection } from '../components/IncludesSection';
import { ForWhomSection } from '../components/ForWhomSection';
import { PricingSection } from '../components/PricingSection';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <>
      <main className="w-full min-h-screen bg-white" data-id="element-135">
        <Hero data-id="element-136" />
        <ProblemSection data-id="element-137" />
        <FailedSolutionsSection data-id="element-138" />
        <SolutionSection data-id="element-139" />
        <IncludesSection data-id="element-140" />
        <ForWhomSection data-id="element-141" />
        <PricingSection data-id="element-142" />
        <FinalCTA data-id="element-143" />
      </main>
      <Footer data-id="element-144" />
    </>;
}